<template>
  <div class="cw-container" ref="myChart"></div>
</template>
<script>
  require('echarts-wordcloud')
  export default {
    props: {
      item: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        var symbolUrl =
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABACAYAAAC0oEFtAAAAAXNSR0IArs4c6QAABWdJREFUeF7tnHuoZXMUxz/fQt6JkH+mlPFOHjczSgymeZQJIeKO5zChm0f5QzOTwXWVwiTPUaOMiaEGIxmmGY9/CHMJkdcUIyHGI/5Qamndfufa59zz2I/fPufczl51Ovfcs9b6/X6fs/Zv7b1/67dFDjGzucBM4EjgOOBA4KDw/jPgr5/Cu//9JbBR0vc5mkttYmbHAucDB4f+eJ9qr72BX4Bfw/s24DPgY0kfpG4kKCqtgZntBgwDi4E5ae0a9N4EXgG2ShrP6aPOzMzOBM4CzgGOyelzPbBWkvctlXQEZ2a7ArcGaEel8ppO6QXgIUlb06nXa5nZtYC/Tspj38LGf1gHuKaTz7bgzOwQ4Dng1E6OCnz/JHC/pE/T+CgJWGPT6yVd3K4/LcGZmc9dbwD7pxlQQZ3twJWS3m7nx8xuB1YWbCutufdpjqQdzQyagjOzWcC7aVuIpPcHcJmkjc38dRlasgtDkjyR1MkUcOHw/CESjKxufgfOkPRR0tDMbvD5MKuziPq7S/on6a8OnJntBWwBPOJ6JS9KOq/WeMiamwBPUr2SNZKubgfueeCCXvUu0e5SSav9s5n5OVbMzJl3eCsl3VEznoy4cFK7Oa/XyHbbJA2FDPp4ZN953fmJ8yxJ37iDJLi14Vwtr+PYdpcAN/Z42mgc0ypJN0+CM7Mh4P3YIy/oz09CryroI7b5vyHqxicizsxGgWWxWyno7ztgRkEfZZgvkzRWA/cJ4BfIlXQmsEXSXJnZPOC1zvqVxmRGleTgbgPGKiyZCBzh4J4FLspkVikvcnAfAsdXLDIRGHFwvwH7ZTKrlEcd3J/APhWLTARWObgvgMMzmVXKE+D8ZmXeNYRBRTgB7mHg+kElkHPcSxycQ3N4laQnMNvB+WHqh2sl6Qjs9Gvo2rXqj2ERN53pYGutkzRcA/cEsGSweaQe/bCkdTVwi7xEIbXp4Cr6YTpT0s7kHeB3gNmDyyTVyB+R5CtudbfO/ULfL/graU7A1xxOkfRVHTj/YGYbgMmluYpgHYEVkvxO+YQ0rqueBrxVAZtCwOtaPNr+agouRN29oTqp4vc/gcWSnk4CaVU74hnWM20lMCZpykJWK3CHAa8C/j7IskGSV3hOkXZlXmcDLw8wtc+BhZK+zQQuzHdeielz3iDKAkktV//SlLIO4irYuZJeahctHcGFyLsJeGBAwm6+pNc7jTUVuABvKfBYJ4fT/PvTO5XTtjyPazdwM7sFuG+aw2nV/ZMlpS48Sh1xtdZ6WItb5u+VOtJyRVwCnpeyP1PmSLroe0aryvLCyaGZAzM7AYiyO6aLkJJN7ZCUu4ws86GabNnM9gS8ju2AHg0+b7ObJXmVVm4pBC5x6HrkeQROB/FtUCNFOxoFXDhd8Tmv7Taeop2NYD8iKcp+iWjgArxubhnKynGepGhV9VHBBXj9lnF9j+qJeTJnKVm1ndOQcX0L475ZwyKy/rikUjaXRI+4RMLwjPtegc23RRnWbW0q6qzRvjRwCYB+Q3RB7I538PegJN9cUpqUDi7Me74v65rSRlHvOFrm7Poc16xBM1sO3FUiPN/vemHMzNkX4BIZ17ca7REZoD/Nwe/YNt3NHLmtCXddOVSTHQ8Z1ysGYpXPbpK0sAw4fRNxDRnXlyD9sRdFZLUkv8Hadel6xDVEnz8B4oqco14u6e6ctoXNegouzHt3AisyjORv4DpJvr+2Z9JzcAGeFzU+CuzSgcTXXgApqef1LX0BLsCbH+Ad2gKeX8L54zW6ljn7Ljm06pCZHR3gedVUUp6SdHnPjssmDfdNxDVkXL/SuDT8b1RSljmwK3z7DlwC4D3Adkle2N138h9Pho/lD/22RQAAAABJRU5ErkJggg=='
        var presents = [
          '有更多经济需求',
          '娱乐活动简单',

          '社交空间单一',
          '集市设施简陋',
          '游客体验感不高',
          '日常较单一',
          '集市停车不便',
          '菜市场利用不高',
          '主街界面封闭',
          '公共空间基本没有',
          '空间利用率低',
          '村镇缺乏活力',
          '缺乏儿童游乐空间',
          '建筑风格少特点',
          '认知度不高',
          '优质的自然人文资源没发挥最好作用',
        ]

        let data = []
        for (let i = 0; i < presents.length; ++i) {
          data.push({
            name: presents[i],
            value: (presents.length - i) * 20,
          })
        }
        for (let i = 10; i < presents.length; ++i) {
          let cnt = Math.floor(Math.random() * 10)
          for (let j = 0; j < cnt; ++j) {
            data.push({
              name: presents[i],
              value: Math.random() * 10,
            })
          }
        }

        var maskImage = new Image()
        maskImage.onload = function () {
          myChart.setOption({
            tooltip: {
              show: false,
            },
            grid: {
              left: 0,
              bottom: 0,
              top: 0,
              right: 0,
            },
            xAxis: {
              type: 'category',
              show: false,
            },
            yAxis: {
              max: 100,
              show: false,
            },
            series: [
              {
                type: 'wordCloud',
                sizeRange: [10, 50],
                rotationRange: [0, 0],
                maskImage: maskImage,
                textPadding: 50,
                gridSize: 5,
                width: '100%',
                height: '100%',
                left: 'center',
                top: 'center',
                drawOutOfBound: false,
                textStyle: {
                  normal: {
                    color: '#ffffff',
                  },
                },
                data: data,
              },
            ],
          })
        }
        maskImage.src = symbolUrl
      },
    },
  }
</script>
<style lang="scss" scoped>
  .cw-container {
    height: 100%;
    width: 100%;
  }
</style>
